import React from 'react';
import './App.css';
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./features/auth/AuthProvider";
import {NotificationProvider} from "./common/notification";
import AuthRouts from "./features/AuthRouts";

function App() {
    return (
        <NotificationProvider>
            <BrowserRouter>
                <AuthProvider>
                   <AuthRouts/>
                </AuthProvider>
            </BrowserRouter>
        </NotificationProvider>
    );
}

export default App;
